import React from 'react'
import { Row, Col} from 'antd'

import { connect } from 'react-redux'
import moment from 'moment'
import 'pages/Salary/index.scss'
import './index.scss'
import { useHistory } from 'react-router-dom'

import CreditList from "pages/Credits/components/CreditList";
import {ScreenTitle} from "components/ScreenTitle";
import {dateFormatter} from "../../services/helper";
import { useTranslation } from 'react-i18next'

const Credits: React.FC<any> = () => {
    const {t} = useTranslation()
    const history = useHistory()

    const onClickRight = () => {
      window.location.reload()
    }
    const onClickLeft = () => {
      history.push('/')
    }
    return (
        <>
            <Row>
                <Col span={24} className="transfer">
                    <ScreenTitle
                     onClickRight={onClickRight}
                     onClickLeft={onClickLeft}
                     leftValue={t("home.loans")} 
                     rightValue={dateFormatter(new Date())}/>
                    <div className='tableBox'>
                        <CreditList/>
                    </div>
                </Col>
            </Row>
        </>
    )
}
const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, null)(Credits)
